/**
 * @description Gestion du fil d'ariane / Breadcrumb
 */

/* global bsBreakpoints */

(() => {
	// VARS
	const breakpoint = bsBreakpoints.detectBreakpoint();
	const breadcrumb = document.querySelector('.breadcrumb');
	const breadcrumbLink = document.querySelector('.breadcrumb__home-btn');

	// FUNCTION
	const breadcrumbRwd = () => {
		if (breakpoint === 'xSmall' || breakpoint === 'small') {
			breadcrumbLink.setAttribute('href', 'javascript:history.back()');
		}
	};

	// GO 🚀
	if (document.body.contains(breadcrumb)) {
		breadcrumbRwd();
	}
})();
